import { render, staticRenderFns } from "./DataDiscoveryHeader.vue?vue&type=template&id=1a841690"
import script from "./DataDiscoveryHeader.vue?vue&type=script&lang=js"
export * from "./DataDiscoveryHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports